import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes,
  // scrollBehavior: () => ({ y: 0 }),
});

router.beforeEach((to, from, next) => {
  document.title = to.params.title ? `${to.params.title} | Profunda Physiotherapie in Würzburg` : `${to.meta.title}`;
  next();
  setTimeout(() => {
    if (to.params.target) {
      const target = document.getElementById(to.params.target);
      window.scrollTo({
        top: target.offsetTop,
        left: 0,
        behavior: 'smooth'
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, 500);
});

export default router;
